// Class: motion.easing.Expo

var $global = typeof window != "undefined" ? window : typeof global != "undefined" ? global : typeof self != "undefined" ? self : this

$global.Object.defineProperty(exports, "__esModule", {value: true});

var __map_reserved = {};

// Imports

var $hxClasses = require("./../../hxClasses_stub").default;
var $import = require("./../../import_stub").default;
function motion_easing__$Expo_ExpoEaseIn() {return require("./../../motion/easing/_Expo/ExpoEaseIn");}
function motion_easing__$Expo_ExpoEaseInOut() {return require("./../../motion/easing/_Expo/ExpoEaseInOut");}
function motion_easing__$Expo_ExpoEaseOut() {return require("./../../motion/easing/_Expo/ExpoEaseOut");}

// Constructor

var Expo = function(){}

// Meta

Expo.__name__ = ["motion","easing","Expo"];
Expo.__isInterface__ = false;
Expo.prototype = {
	
};
Expo.prototype.__class__ = Expo.prototype.constructor = $hxClasses["motion.easing.Expo"] = Expo;

// Init



// Statics


Expo.easeIn = new (motion_easing__$Expo_ExpoEaseIn().default)()
Expo.easeInOut = new (motion_easing__$Expo_ExpoEaseInOut().default)()
Expo.easeOut = new (motion_easing__$Expo_ExpoEaseOut().default)()

// Export

exports.default = Expo;